<template>
    <v-bottom-sheet
        :value="cookiesAccepted && updateExists"
        persistent
        :overlay-opacity="0.2"
    >
        <v-sheet class="pa-5" color="blue-grey darken-4" dark>
            <v-row align="center">
                <v-col cols="12" class="body-2 text-center">
                    An update to the app is available.
                </v-col>
                <v-col class="text-center" cols="12">
                    <v-btn class="primary" depressed @click="refreshApp">Update</v-btn>
                </v-col>
            </v-row>
        </v-sheet>
    </v-bottom-sheet>
</template>

<script>
import update from '@/mixins/update';
import { mapGetters } from 'vuex';

export default {
  name: 'PromptUpdateApp',

  mixins: [update],

  computed: {
    ...mapGetters([
      'cookiesAccepted',
    ]),
  },
};
</script>

<style lang="scss">

</style>
